module.exports = __webpack_public_path__ + "media/images/weather/850_night-27129af4f7c83bb09fee904258584d23.png";